import React from 'react';
import { ListItemButton, styled } from '@mui/material';
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import { listItemTextClasses } from '@mui/material/ListItemText';

// Grupo colapsable (p. ej. "Pagos"). Alineado con StyledMainMenuButton: radio 13,
// alto 46, selección NEUTRA (gris, sin dorado ni barra dorada). En modo icono
// (rail) queda centrado como el resto de ítems.
const StyledCollapsibleMenuItemButton = styled(({ noLink, ...otherProps }) => (
  <ListItemButton disableRipple={noLink} {...otherProps} />
))(({ noLink, theme }) => ({
  borderRadius: '13px',
  marginBottom: '2px',
  minHeight: 46,
  padding: noLink ? '0' : `${theme.spacing(1)} ${theme.spacing(2)}`,
  '&:hover': {
    background: theme.palette.mode === 'light' ? 'rgba(17, 21, 27, 0.06)' : 'rgba(255, 255, 255, 0.08)'
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.selected.bg,
    [`& .${listItemTextClasses.root}, & .${listItemIconClasses.root}`]: {
      color: theme.palette.selected.fg
    },
    '&:hover': {
      backgroundColor: theme.palette.selected.bg
    }
  }
}));

export default StyledCollapsibleMenuItemButton;
